import { createTheme } from "@mui/material/styles";

export const getTheme = (mode) => {
  return createTheme({
    palette: {
      mode,
      primary: {
        main: mode === "dark" ? "#857e7f" : "#007AFF",
      },
      secondary: {
        main: "#14A44D",
      },
      text: {
        primary: mode === "dark" ? "#fff" : "#1C1C1E",
        secondary: mode === "dark" ? "#850F8D" : "#5A5A5A",
        constant: "#fff",
        successLight: "#27AE60",
        successDark: "#00C853",
      },
      background: {
        default: mode === "dark" ? "#0c1121" : "#F7F9FC",
        primary: mode === "dark" ? "transparent" : "#E3E7EC",
        secondary: "gray",
        paper: mode === "dark" ? "#161e3b" : "#FFFFFF",
      },
      announcement: {
        background: mode === "dark" ? "#1e293b" : "#E3F2FD",
        border: mode === "dark" ? "#334155" : "#90CAF9",
        badgeBg: "#ef4444",
        badgeText: "#fff",
        link: mode === "dark" ? "#22d3ee" : "#0D47A1",
        text: mode === "dark" ? "#fff" : "#1C1C1E",
      },

    },

    components: {
      linkgen: {
        textAlign: "center",
        display: "block",
        fontWeight: "bold",
        fontSize: "20px",
        marginTop: "16px",
        textDecoration: "none",
        color: mode === "dark" ? "#fff" : "black",
        border: mode === "dark" ? "1px solid #14d9fd" : "1px solid #B0BEC5",
        padding: 4,
      },

      MuiLink: {
        styleOverrides: {
          root: {
            textDecoration: "none",
            color: "inherit",
            border: `1px solid ${mode === "dark" ? "#14d9fd" : "#B0BEC5"}`,
            padding: "8px 16px",
            borderRadius: "4px",
            "&:hover": {
              borderColor: mode === "dark" ? "#12b4d1" : "#007AFF",
            },
          },
        },
      },

      MuiButton: {
        styleOverrides: {

          //reset popup
          resetCancel: {
            mt: 2,
            borderRadius: "20px",
            py: 2,
            px: 4,
            borderColor: mode === "light" ? "#138496" : undefined,
            background: mode === "light" ? "#17A2B8" : "#155E95",
            color: "white",
            "&:hover": {
              background: mode === "light" ? "#138496" : "#ffcccb",
              color: mode === "light" ? "white" : "black",
            }
          },
          resetConfirm: {
            borderRadius: "20px",
            mt: 2,
            py: 2,
            px: 4,
            borderColor: "#802020",
            background: mode === "light" ? "#A52A2A" : "#FF4C4C",
            "&:hover": {
              background: mode === "light" ? "#802020" : "ffcccb",
              color: mode === "light" ? "white" : "black",
            }
          },
          linkButton: {
            width: { xs: "100%", sm: "auto" }, // Full width on xs, auto on others
            minWidth: { xs: "250px", sm: "auto" },
            py: 1.5,
            mt: 2,
            fontSize: { xs: "0.9rem", sm: "1rem", md: "1.2rem" },
            fontWeight: "bold",
            whiteSpace: "nowrap", // Prevents line break
            background: mode === "dark"
              ? "linear-gradient(to right, #ec407a, #fb8c00)"
              : "linear-gradient(to right, #00b09b, #96c93d)",
            color: "#fff",
            "&:hover": {
              opacity: 0.9,
            },
          },
          whatsappButton: {
            borderRadius: "20px",
            py: 2,
            px: 4,
            mb: { xs: 2, sm: 0 },
            backgroundColor: mode === "dark" ? "#27a219" : "#14A44D",
            "&:hover": {
              backgroundColor: mode === "dark" ? "#73e266" : "#28B463",
              color: "#fff",
            },
          },
          resetButton: {
            borderRadius: "20px",
            py: 2,
            px: 4,
            background: mode === "dark" ? "#FF4C4C" : "#E0E0E0",
            color: mode === "dark" ? "#fff" : "black",
            "&:hover": {
              background: mode === "dark" ? "#ffcccb" : "#D5DBDB",
              color: "black",
            },
          },
          root: {
            backgroundColor: mode === "dark" ? "#14d9fd" : "",
            color: mode === "dark" ? "#14d9fd" : "#fff",
            borderRadius: "8px",
            padding: "8px 16px",
            "&:hover": {
              backgroundColor: "#5D6D7E",
            },
          },
          contained: {
            backgroundColor: mode === "dark" ? "#e91e63" : "#007AFF",
            color: "#fff",
            "&:hover": {
              backgroundColor: mode === "dark" ? "#D91656" : "#005BBB",
            },
          },
          outlined: {
            color: mode === "dark" ? "#14d9fd" : "#007AFF",
            borderColor: mode === "dark" ? "#14d9fd" : "#007AFF",
            "&:hover": {
              backgroundColor: mode === "dark" ? "rgba(20, 217, 253, 0.08)" : "rgba(0,122,255,0.08)",
              borderColor: mode === "dark" ? "#12b4d1" : "#005BBB",
              color: mode === "dark" ? "#12b4d1" : "#005BBB",
            },
          },
        },
      },

      MuiTextField: {
        styleOverrides: {
          root: {
            "& .MuiOutlinedInput-root": {
              "& fieldset": {
                borderColor: mode === "light" ? "#B0BEC5" : "#494957",
              },
              "&:hover fieldset": {
                borderColor: mode === "light" ? "#007AFF" : "#14d9fd",
              },
              "&.Mui-focused fieldset": {
                borderColor: mode === "light" ? "#007AFF" : "#14d9fd",
              },
            },
            "& .MuiInputBase-root": {
              backgroundColor: mode === "dark" ? "#161e3b" : "#FFFFFF",
              color: mode === "dark" ? "#fff" : "#1C1C1E",
              borderRadius: "8px",
            },
            "& .MuiInputLabel-root": {
              color: mode === "light" ? "#5A5A5A" : "#14d9fd",
            },
            "& .MuiInputLabel-root.Mui-focused": {
              color: mode === "dark" ? "#14d9fd" : "#007AFF",
            },
            "& .MuiInputBase-input[readonly]": {
              color: mode === "light" ? "#1C1C1E" : "#fff",
              backgroundColor: mode === "light" ? "#E5E8E8" : "#161e3b",
              WebkitTextFillColor: mode === "light" ? "#1C1C1E" : "#fff",
            },
          },
        },
      },

      MuiIconButton: {
        styleOverrides: {
          root: {
            color: "#14d9fd",
            "&:hover": {
              backgroundColor: "#12b4d1",
              color: "black",
            },
          },
        },
      },
    },
  });
};
